import "../../src/assets/styles/Header.css";
import logo from "../imgs/logo.webp";
import { useNavigate } from "react-router-dom";
function Header({ isPageSearch, pageToAcction, data }) {
  const navigate = useNavigate();
  const backToSearch = () => {
    if (pageToAcction) navigate(pageToAcction, { state: data });
    else navigate("/");
  };

  return (
    <div className="header">
      <div className="header-logo" onClick={backToSearch}>
        {!isPageSearch && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon-back"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="m12 8-4 4 4 4" />
            <path d="M16 12H8" />
          </svg>
        )}
        <div className="main-logo">
          <img src={logo} alt="logo"></img>
        </div>
      </div>
      <p>HỖ TRỢ KHÁCH HÀNG</p>
    </div>
  );
}

export default Header;
